import { INaturalTextBehavior, INaturalTextBehaviorSpecifiable } from "../../../../../../../documaker/domain/format/objects";
import { IObjectBeanNaturalTextPresentable } from "../../../beans/objects";

export class NaturalTextBehaviorTranslator {
  from(bean: IObjectBeanNaturalTextPresentable): INaturalTextBehavior {
    return {
      isEnable: (bean["@natural-view"] === "1"),
      text: bean["@natural-text"] ? bean["@natural-text"] : "",
    };
  }

  to(o: INaturalTextBehaviorSpecifiable) {
    return {
      naturalView: o.naturalTextBehavior.isEnable
        ? "1"
        : undefined,
      naturalText: o.naturalTextBehavior.isEnable
        ? o.naturalTextBehavior.text
        : undefined,
    };
  }
}
